export function isLocalDev() {
  return import.meta.env.DEV;
}

export function getBasePathWithTrailingSlash() {
  return import.meta.env.BASE_URL;
}

export function getBasePathWithoutTrailingSlash() {
  return getBasePathWithTrailingSlash().replace(/\/$/, "");
}
